import Vue from 'vue'
import Vuex from 'vuex'

import utils from '../utils'

// load schemas
import networkSchema from '../schema/network.json'
import stationSchema from '../schema/station.json'
import locationSchema from '../schema/location.json'
import devicesSchema from '../schema/devices.json'
import addChannelCollectionSchema from '../schema/addChannelCollection.json'

import defaultData from './default_data.json'
import * as mutations from './mutations'
import * as getters from './getters'
import * as actions from './actions'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    data: defaultData,

    seed: 100,

    stationStruct: {
      id: -1,
      label: 'XXXXX',
      location: [],
      channel: []
    },

    context: null,
    node: null,
    stationNode: null,
    nodeType: null,
    schema: null,

    schemaCollection: {
      network: networkSchema,
      station: stationSchema,
      location: locationSchema,
      devices: devicesSchema,
      channel_collection: addChannelCollectionSchema
    },

    deviceInventory: null,
    softwareFilters: null,

    values: null
  },

  getters,

  mutations,

  actions

})
